import { Component, Input, OnInit } from '@angular/core';
import { DimensionModel } from 'src/app/model/InstrumentoAutoevaluacion.model';


@Component({
  selector: 'app-ins-autoevaluacion-dimension',
  templateUrl: './ins-autoevaluacion-dimension.component.html',
  styleUrls: ['./ins-autoevaluacion-dimension.component.css']
})
export class InsAutoevaluacionDimensionComponent implements OnInit {

  @Input() dimensionData : DimensionModel;
  @Input() simulacion : boolean;
  @Input() isModificable : boolean;

  public isCollapsed = true;

  constructor() { }

  ngOnInit(): void {
  }

}
